// SERVICES
import { downloadImage } from 'js/library/services/StorageManager';

// LIBS
import { deburr } from 'lodash';

// API
import { GetOrgsPaginatedSearch } from 'js/library/utils/API/Org/apiGetOrgsPaginatedSearch';
import { getKeywords } from 'js/library/utils/API/SearchUser/apiGetKeywords';

/* ========== DATA FETCHING ========== */
export async function fetchOrganizations(orgsSuggestions, form, setForm) {
  const currentOrganizationsList = [];
  const payload = {
    from: 0,
    size: 10000,
    accessMethod: 'all',
    visibility: 'all',
  };
  const data = await GetOrgsPaginatedSearch(payload);

  if (data) {
    const resultArrayValues = data.results;

    form.orgIDList.forEach((org) => {
      currentOrganizationsList.push(...resultArrayValues.filter((value) => value.orgID === org));
    });

    orgsSuggestions.push(...resultArrayValues.map((value) => ({ ...value })));

    setForm((prevForm) => ({
      ...prevForm,
      organizationsList: [...currentOrganizationsList],
    }));
  }
}

export async function fetchKeywords() {
  const dataReceived = await getKeywords();
  return Object.values(dataReceived).map((item) => ({ label: item.value }));
}

// download images
export async function downloadCardImages(
  infosForEdit,
  form,
  setCardDefaultWeb,
  setCardDefaultMobile,
  setCardDefaultDetails
) {
  if (infosForEdit.images !== undefined) {
    if (infosForEdit.images.web !== undefined) {
      downloadImage('cards', form.imageWeb)
        .then(setCardDefaultWeb)
        .catch(() => {});
    }

    if (infosForEdit.images.mobile !== undefined) {
      downloadImage('cards', form.imageMobile.split('/')[1])
        .then(setCardDefaultMobile)
        .catch(() => {});
    }

    if (infosForEdit.images.mobileDetails !== undefined) {
      downloadImage('cards', form.imageMobileDetails.split('/')[1])
        .then(setCardDefaultDetails)
        .catch(() => {});
    }
  }
}

/* ========== QUERY HELPERS ========== */
export function detectCardType(storePlacesQuery) {
  if (!storePlacesQuery) return null;

  if (storePlacesQuery.establishmentType) return 'establishment_list';
  if (storePlacesQuery.promotionType) return 'promotion_list';
  if (storePlacesQuery.productType) return 'product_list';

  return null;
}

export function validateSystemQuery(systemQuery) {
  const errors = {};

  if (!systemQuery) return errors;

  Object.entries(systemQuery).forEach(([groupName, conditions]) => {
    conditions.forEach((condition, index) => {
      if (
        condition.value === '' ||
        condition.value === null ||
        condition.value === undefined ||
        (Array.isArray(condition.value) && condition.value.length === 0)
      ) {
        if (!errors[groupName]) errors[groupName] = {};
        errors[groupName][index] = true;
      }
    });
  });

  return errors;
}

export function reorganizeSystemQueryGroups(systemQuery) {
  if (!systemQuery) return systemQuery;

  // Pega todos os grupos existentes e ordena pelas chaves numéricas
  const groups = Object.entries(systemQuery)
    .map(([key, value]) => ({
      key,
      value,
      num: parseInt(key.replace('grupo', '')),
    }))
    .sort((a, b) => a.num - b.num);

  // Cria novo objeto com grupos renumerados
  const newSystemQuery = {};
  groups.forEach((group, index) => {
    const newKey = `grupo${index + 1}`;
    newSystemQuery[newKey] = group.value;
  });

  return newSystemQuery;
}

/* ========== UI HELPERS ========== */
// para org e keyword
export function getSuggestions(type, value, orgsSuggestions, suggestions) {
  const inputValue = deburr(value.trim()).toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  if (type === 'orgs')
    return inputLength === 0
      ? []
      : orgsSuggestions.filter((suggestion) => {
          const keep =
            count < 5 && suggestion.name.slice(0, inputLength).toLowerCase() === inputValue;

          if (keep) {
            count += 1;
          }

          return keep;
        });

  return inputLength === 0
    ? []
    : suggestions.filter((suggestion) => {
        const keep =
          count < 5 && suggestion.label.slice(0, inputLength).toLowerCase() === inputValue;

        if (keep) {
          count += 1;
        }

        return keep;
      });
}

/* ========== TYPE HANDLERS ========== */
export function handleAction(event, form, setForm, cardTypes, returnType, setSelectedCardType) {
  const newAction = event.target.value;
  const selectedCardType = cardTypes.find((card) => card.action === newAction);

  // Atualiza o form com a nova action
  const updatedForm = {
    ...form,
    action: newAction,
  };

  // Inicializa storePlacesQuery se não existir
  if (!updatedForm.storePlacesQuery) {
    updatedForm.storePlacesQuery = {};
  }

  // Remove os tipos anteriores
  delete updatedForm.storePlacesQuery.establishmentType;
  delete updatedForm.storePlacesQuery.promotionType;
  delete updatedForm.storePlacesQuery.productType;

  // Adiciona o novo tipo baseado no card selecionado
  if (selectedCardType) {
    const key = `${selectedCardType.action.split('_')[0]}Type`; // ex: "promotionType"
    updatedForm.storePlacesQuery[key] = [...returnType]; // Usa o returnType atual
  }

  setForm(updatedForm);
  if (selectedCardType) {
    setSelectedCardType(selectedCardType);
  }
}
